import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const EditFIll = ({ color = '#838685', ...rest }: Props) => {
  return (
    <Svg
      width={28}
      height={29}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="edit_FILL0_wght400_GRAD0_opsz24 1">
        <path
          id="Vector"
          d="M5.83333 22.2057H7.49583L18.9 10.8016L17.2375 9.13906L5.83333 20.5432V22.2057ZM3.5 24.5391V19.5807L18.9 4.2099C19.1333 3.99601 19.391 3.83073 19.6729 3.71406C19.9549 3.5974 20.2514 3.53906 20.5625 3.53906C20.8736 3.53906 21.175 3.5974 21.4667 3.71406C21.7583 3.83073 22.0111 4.00573 22.225 4.23906L23.8292 5.8724C24.0625 6.08628 24.2326 6.33906 24.3396 6.63073C24.4465 6.9224 24.5 7.21406 24.5 7.50573C24.5 7.81684 24.4465 8.11337 24.3396 8.39531C24.2326 8.67726 24.0625 8.9349 23.8292 9.16823L8.45833 24.5391H3.5ZM18.0542 9.9849L17.2375 9.13906L18.9 10.8016L18.0542 9.9849Z"
          fill={color}
        />
      </g>
    </Svg>
  )
}

export default EditFIll
